<template>
<div>
  <v-container v-if="requestLoading">
    <v-row>
      <v-col cols="12" lg="8" class="title">
        ProfileID#{{ armorySelectedProfileID }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="8">
        <v-progress-circular
          :indeterminate="!requestLoading"
          :value="requestProgress"
          color="yellow"
          class="mr-3"
        ></v-progress-circular>
        <span>{{ requestStatus }}</span>
        <v-alert
          class="mt-3"
          :value="outputAlert"
          type="error"
          transition="scale-transition"
        >
          {{ outputMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-if="profileInformationReady && !requestLoading">
    <v-row>
      <v-col cols="12" lg="8" class="title">
        {{ battleTag }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="10" md="6" lg="5">
        <v-row class="good3-flex--bg pa-1">
          <v-col cols="12" class="good3-flex--title">
            Parangons
          </v-col>
        </v-row>
        <v-row class="good3-flex--bg pa-1">
          <v-col cols="8" class="pa-0">
            <v-row>
              <v-col cols="3"></v-col>
              <v-col cols="3" class="text-center">base</v-col>
              <v-col cols="3" class="text-center">season</v-col>
              <v-col cols="3" class="text-center">total</v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="text-right">softcore</v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon" v-on="on">
                      {{ armorySelectedProfile.parangon }}
                    </div>
                  </template>
                  <span>Softcore parangon level</span>
                </v-tooltip>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon good3-sea" v-on="on">
                      {{ armorySelectedProfile.parangon_sea }}
                    </div>
                  </template>
                  <span>Softcore seasonal parangon level</span>
                </v-tooltip>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon good3-total-sc" v-on="on">
                      {{ armorySelectedProfile.bonus.total_parangon_sc }}
                    </div>
                  </template>
                  <span>Total softcore parangon level (seasonal and non-seasonal)</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="text-right">hardcore</v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon good3-hc" v-on="on">
                      {{ armorySelectedProfile.parangon_hc }}
                    </div>
                  </template>
                  <span>Hardcore parangon level</span>
                </v-tooltip>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon good3-sea-hc" v-on="on">
                      {{ armorySelectedProfile.parangon_sea_hc }}
                    </div>
                  </template>
                  <span>Hardcore seasonal parangon level</span>
                </v-tooltip>
              </v-col>
              <v-col cols="3" class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div class="good3-cardParangon good3-total-hc" v-on="on">
                      {{ armorySelectedProfile.bonus.total_parangon_hc }}
                    </div>
                  </template>
                  <span>Total hardcore parangon level (seasonal and non-seasonal)</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" class="pa-1 text-xs-right text-sm-center" style="align-self: center;">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div class="good3-cardParangon good3-total" v-on="on">
                  {{ armorySelectedProfile.bonus.total_parangon }}
                </div>
              </template>
              <span>Total parangon level (seasonal and non-seasonal)</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="good3-flex--bg pa-1">
          <v-col cols="12" class="good3-flex--title">
            Heroes
          </v-col>
        </v-row>
        <profile-hero-list-item v-for="hero in armoryHeroes" v-bind:hero="hero"></profile-hero-list-item>
      </v-col>
      <v-col cols="12" sm="10" md="6" lg="7">
        <v-row class="good3-flex--bg pa-1">
          <v-col cols="12" class="good3-flex--title">
            Parangons History
          </v-col>
        </v-row>
        <v-row class="good3-flex--bg pa-1">
          <v-col cols="12" v-if="graphUpdateLoading">
            <v-progress-circular
              :indeterminate="!graphUpdateLoading"
              :value="graphUpdateProgress"
              color="yellow"
              class="mr-3"
            ></v-progress-circular>
            <span>{{ graphUpdateStatus }}</span>
            <v-alert
              class="mt-3"
              :value="graphUpdateAlert"
              type="error"
              transition="scale-transition"
            >
              {{ graphUpdateMessage }}
            </v-alert>
          </v-col>
          <v-col cols="12" v-if="profileHistoryReady && !graphUpdateLoading">
            <svg-parangon-history></svg-parangon-history>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
// MIXINS
import { Good3Lib } from '../good3lib/good3_lib'
import { ProfileLib } from '../good3lib/profile_lib'

// VUEX
import { mapGetters } from 'vuex'

// COMPONENTS
import ProfileHeroListItem from './hero/ProfileHeroListItem.vue'
import SVGParangonHistory from './svg/SVGParangonHistory.vue'

// DEFAULT
export default {
  name: 'GOOD3_PageProfile',

  // Importing VUEJS shared resources
  //
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {},
  components: {
    'svg-parangon-history': SVGParangonHistory,
    'profile-hero-list-item': ProfileHeroListItem
  },
  mixins: [Good3Lib, ProfileLib],

  // Accessible properties
  //
  // • data
  // • computed
  // • watch
  data: () => ({
    // page components availability
    profileInformationReady: false,
    profileHistoryReady: false,

    // API calls variables
    requestLoading: false,
    requestProgress: 0,
    requestStatus: '',
    outputAlert: false,
    outputMessage: '',

    // graph updates variables
    graphUpdateLoading: false,
    graphUpdateProgress: 0,
    graphUpdateStatus: '',
    graphUpdateAlert: false,
    graphUpdateMessage: '',

    // Data Table properties
    dataTableHeaders: [
      { text: 'Hero', value: 'name', align: 'left', class: ['yellow--text', 'body-2'] },
      { text: 'Class', value: 'hero_class', align: 'right', class: ['yellow--text', 'body-2'] },
      { text: 'Heroes', value: 'heroes_number', align: 'right', class: ['yellow--text', 'body-2'] },
      { text: 'Last Played', value: 'last_updated', align: 'right', class: ['yellow--text', 'body-2'] }
    ]
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
      'armoryProfiles',
      'armorySelectedProfile',
      'armorySelectedProfileID',
      'armoryHeroes'
    ]),
    battleTag () {
      if (this.armorySelectedProfile !== null) {
        return this.armorySelectedProfile.battle_tag
      } else {
        return 'not set yet'
      }
    }
  },
  watch: {
    // handling Profile to Profile navigation where the component is not reloaded
    '$route' (to, from) {
      this.$store.commit('setSelectedProfileID', to.params.profile_id)
    }
  },

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted
  mounted () {
    // lets store the profile_id provided intot he link
    this.$store.commit('setSelectedProfileID', this.$route.params.profile_id)

    // makes sure we have the full dataset loaded into memory
    // if not the reason is probably that the user has reloaded the page or
    // landed here following a bookmarked link
    if (this.armoryProfiles === null) {
      this.loadProfiles()
    }

    // lets get the full profile and display it
    if (this.armorySelectedProfileID != null) {
      this.loadSelectedProfile()
    }
  },

  // Components methods
  methods: {}
}
</script>

<style scoped>

</style>
